const StarRating = ({ rating, ariaLabel, size = 16 }: StarRatingProps) => (
  <div className="flex gap-0.5" aria-label={ariaLabel}>
    {Array.from({ length: 5 }).map((_, i) => (
      <svg
        key={i}
        aria-hidden="true"
        className={i < Math.round(rating) ? 'text-secondary' : 'text-text/20'}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ))}
  </div>
);

export default StarRating;

type StarRatingProps = {
  rating: number;
  ariaLabel: string;
  size?: number;
};
